let html = `
<svg><use xlink:href="#sprite-lock"></use></svg>
`

export default html